import { MapPin, Phone, Mail, Clock, Heart } from "lucide-react";

const IMG = "https://images.unsplash.com/photo-1591189863430-ab87e120f312?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function About() {
  return (
    <div className="mx-auto max-w-5xl px-4 sm:px-6 py-14">
      <div className="text-center max-w-2xl mx-auto animate-fade-up">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full glass border border-border text-sm text-coral font-medium mb-5">
          <Heart className="h-4 w-4" /> Établissement familial
        </span>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-foreground">À propos de nous</h1>
        <p className="font-accent italic text-coral text-xl mt-3">Depuis 1978</p>
      </div>

      <div className="mt-10 rounded-3xl overflow-hidden border border-border">
        <img src={IMG} alt="Cuisine Traiteur FL" className="w-full h-72 object-cover" />
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-2 text-muted-foreground leading-relaxed">
        <p>
          Francine Lesage Traiteur est implanté dans la ville de Saint-Raymond depuis 1978. Cet établissement familial
          accueille notre passion pour les produits frais du marché et la cuisine authentique, le tout dans une ambiance chaleureuse.
        </p>
        <p>
          Notre menu propose une sélection de plats originaux, tous concoctés sur place par notre équipe de chefs réputés.
          Adoré des locaux, Traiteur FL vous attend pour vous faire découvrir Le Traiteur dans Portneuf.
        </p>
      </div>

      <div className="mt-12 grid gap-4 sm:grid-cols-2">
        <div className="p-6 rounded-2xl bg-ink-800 border border-border">
          <h3 className="font-heading font-bold text-foreground mb-4">Coordonnées</h3>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex gap-3"><MapPin className="h-5 w-5 text-coral shrink-0" /> 374 Saint Joseph, St-Raymond, QC G3L 1J9</li>
            <li className="flex gap-3"><Phone className="h-5 w-5 text-coral shrink-0" /> (418) 987-8317</li>
            <li className="flex gap-3"><Mail className="h-5 w-5 text-coral shrink-0" /> Info@traiteurfl.com</li>
          </ul>
        </div>
        <div className="p-6 rounded-2xl bg-ink-800 border border-border">
          <h3 className="font-heading font-bold text-foreground mb-4 flex items-center gap-2"><Clock className="h-5 w-5 text-coral" /> Horaires</h3>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li className="flex justify-between"><span>Lundi</span><span className="text-muted-foreground">8h00 - 17h30</span></li>
            <li className="flex justify-between"><span>Mardi au vendredi</span><span className="text-muted-foreground">8h00 - 14h00</span></li>
            <li className="flex justify-between"><span>Samedi et dimanche</span><span className="text-muted-foreground">Fermé*</span></li>
          </ul>
          <p className="text-xs text-muted-foreground mt-3">* exception pour les traiteurs</p>
        </div>
      </div>
    </div>
  );
}
